import axios from "axios";
import { GUEST_VOTE_WEB_HEADERS } from "../utils/guestVote";

function normalizeVoteResponse(error) {
  const data = error.response?.data;
  if (!data) return null;
  return {
    success: false,
    message: data.message || "Could not vote",
    remainingVotes: data.remainingVotes,
    dailyVotesUsedToday: data.dailyVotesUsedToday,
    requiresPurchase: Boolean(data.requiresPurchase),
    requiresRegistration: Boolean(data.requiresRegistration),
    guestVotingDisabled: Boolean(data.guestVotingDisabled),
  };
}

export const voteCompetitionVideo = async (videoId, token) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/voteCompetitionVideo`,
      { videoId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    const normalized = normalizeVoteResponse(error);
    if (normalized) return normalized;
    throw new Error(error.message);
  }
};

export const voteCompetitionVideoGuest = async (
  videoId,
  guest_user_id,
  token
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/voteCompetitionVideo`,
      { videoId, guest_user_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...GUEST_VOTE_WEB_HEADERS,
        },
      }
    );
    return response.data;
  } catch (error) {
    const normalized = normalizeVoteResponse(error);
    if (normalized) return normalized;
    throw new Error(error.message);
  }
};
